<template>
    <div class="multiselect__caret" v-if="!hide" v-on="$listeners">
      <font-awesome-icon
              :icon="[solid ? 'fas' : 'fal', 'chevron-down']"
              size="xs"
      >
      </font-awesome-icon>
    </div>
</template>

<script>
export default {
  name: 'Caret-Icon',
  props: {
    solid: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Boolean,
      default: false,
    }
  }
};
</script>
